<template>
  <el-dialog :visible.sync="visible" title="审批" width="60%" :close-on-click-modal="false" append-to-body @opened="openfun">
    <div>
      <el-form :model="approvalObj" label-width="120px" :rules="rules" ref="approvalRef">
        <!--        <el-form-item label="订单号">-->
        <!--          {{ approvalObj.orderNo }}-->
        <!--        </el-form-item>-->
        <el-form-item v-if="approvalObj.applyMoney" label="申请金额" prop="applyMoney">
          <el-input-number style="min-width: 200px" v-model="approvalObj.applyMoney" :precision="2" disabled></el-input-number>
        </el-form-item>
        <el-form-item v-if="approvalObj.applyMoney" label="批复金额" prop="approveMoney">
          <el-input-number style="min-width: 200px" v-model="approvalObj.approveMoney" :precision="2" :step="1" @change="changeVal"></el-input-number>
        </el-form-item>
        <el-form-item label="审批意见" prop="content">
          <el-input v-model="approvalObj.content" type="textarea" :rows="3" placeholder="请输入审批意见"></el-input>
        </el-form-item>
        <el-form-item label="审批结果" prop="result">
          <el-radio-group v-model="approvalObj.result" v-removeAriaHidden>
            <el-radio label="pass">通过</el-radio>
            <el-radio label="rejected">拒绝</el-radio>
            <el-radio v-show="rollbackSteps.length > 0 || orderStatus === 'prepareAudit' " label="rollback">退回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="approvalObj.result === 'rollback' && orderStatus !== 'prepareAudit' " label="退回步骤" prop="result">
          <el-radio-group v-model="approvalObj.result">
            <el-select v-model="approvalObj.backStepId" placeholder="请选择退回到步骤">
              <el-option v-for="item in rollbackSteps" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button @click="resetForm('approvalRef')">重置</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitForm('approvalRef')">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {auditTask, getAuditData} from "@/api/sys/flow/audit";
import {successMsg} from "@/utils/message";

export default {
  name: "authDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    orderNo: {
      type: String,
      require: true
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    }
  },
  data() {
    return {
      isLoading: false,
      rules: {
        content: [
          {required: true, message: '请输入审批意见', trigger: 'blur'},
          {min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur'}
        ],
        result: [
          {required: true, message: '请选择审批结果', trigger: 'change'}
        ]
      },
      rollbackSteps: [],
      orderStatus: '',
      approvalObj: {
        orderNo: '',
        content: '',
        result: '',
        backStepId: ''
      }
    }
  },
  created() {
    getAuditData(this.orderNo).then(res => {
      this.approvalObj = {
        id: res.id,
        orderNo: res.orderNo,
        flowId: res.flowId,
        result: 'pass',
        content: '',
        backStepId: null
      }
      this.orderStatus = res.currentStep.code
      if (res.applyMoney) {
        this.approvalObj.applyMoney = Number(res.applyMoney)
        this.approvalObj.approveMoney = Number(res.applyMoney)
      }
      if(res.approveMoney){
        this.approvalObj.approveMoney = Number(res.approveMoney)
      }
      //stepList 找到id与currentStep相同的位置 获取之前的节点给rollbackSteps
      const currentIndex = res.stepList.findIndex(item => item.code === res.currentStep.code)
      if (currentIndex !== -1) {
        this.rollbackSteps = res.stepList.slice(0, currentIndex).reverse();
        this.approvalObj.backStepId = this.rollbackSteps[0]?.id
      }
    })
  },
  methods: {
    openfun() {
      this.$refs['approvalRef'].clearValidate()
    },
    resetForm(ref) {
      this.$refs[ref].resetFields()
    },
    //  提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          auditTask(this.approvalObj).then(() => {
            successMsg('操作成功')
            this.visible = false
            this.isLoading = false
            this.$emit('submit-success')
          }).catch(() => {
            this.isLoading = false
          })
        }
      })
    },
    changeVal() {
      this.$forceUpdate();
    }
  }
}

</script>

<style scoped>

</style>
